<template>
    <div class="row">
        <div class="col-sm-12">
            <div class="ibox">
                <div class="ibox-title">
                    <div class='detailtit'><span id="gartenNum"></span></div>
                    <el-form id="elForm" :model="queryForm" ref="queryForm" :inline="true"  class="demo-form-inline" label-width="85px" size="medium">
                        <el-form-item label="市：" prop="cityID" v-show="cityVisible">
                            <el-select v-model="queryForm.cityID" @change="selectChange('city',queryForm.cityID)" style="width:205px;">
                            <el-option v-for="item in selectcity" :key="item.id" :label="item.name" :value="item.id"></el-option>
                        </el-select>
                        </el-form-item>
                        <el-form-item label="区县：" prop="countryID">
                            <el-select v-model="queryForm.countryID">
                                <el-option v-for="item in selectarea" :key="item.id" :label="item.name" :value="item.id"></el-option>
                            </el-select>
                        </el-form-item>
                         <el-form-item label="上报日期：" prop="date">
                            <!-- <el-date-picker v-model="formInline.date" :default-value="formInline.date" type="daterange" align="right" placeholder="选择日期范围" :picker-options="pickerOptions"></el-date-picker> -->
                            <double-date v-model="queryForm.date" :modelData="queryForm.date" modelKey="date" :data="queryForm" startKey="startDate" endKey="endDate"  style="width:205px;"></double-date>
                        </el-form-item>
                        <el-form-item label="上报状态：">
                            <el-select v-model="queryForm.reportStatus">
                                <el-option label="全部" value="1"></el-option>
                                <el-option label="已上报" value="2"></el-option>
                                <el-option label="未上报" value="3"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="机构类型：">
                            <el-select v-model="queryForm.orgFirstType" @change="changeType()">
                                <el-option label="全部" value=""></el-option>
                                <el-option label="公办" value="1"></el-option>
                                <el-option label="民办" value="2"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="机构级别：" ref="orgSecondType" v-show="orgSecondType">
                                  <el-select v-model="queryForm.orgSecondType" style="width:205px;">
                                  <el-option v-for="item in org" :key="item.id" :label="item.name" :value="item.id"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item>
                            <el-button class="btn-primary" @click="query">查询</el-button>
                        </el-form-item>
                    </el-form>
                    <!-- 操作按钮 -->
                    <div class="mb15">
                        <el-button @click="opederive()"><i class="el-icon-download"></i>&nbsp;导出</el-button>
                    </div>
                    <!-- 用户列表-->
                    <el-table :data="tableData" border class="table-bordered"  style="width: 100%">
                        <el-table-column type="selection" current-row-key="orgID" width="55"></el-table-column>
                        <el-table-column prop="fullName" label="幼儿园名称" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="orgFirstTypeStr" label="机构类型" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="orgSecondTypeStr" label="机构级别" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="userName" label="联系人" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="loginTel" label="手机号" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="street" label="地址" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="reportNum" label="上报报表次数" sortable></el-table-column>
                        <el-table-column label="操作">
                            <template slot-scope="scope">
                                <el-button class="btn-warning btn-outline" @click="survey(scope.$index,scope.row)" size="small" plain><i class="el-icon-view"></i>查看</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <!--分页-->
                    <el-pagination :current-page.sync="queryForm.pageNum" :page-sizes="[10, 20, 50, 100]" :page-size="queryForm.pageSize"
                        layout="total, sizes, prev, pager, next, jumper" :total="total_rows"
                        @size-change="pageSizeChange" @current-change="pageCurrentChange" style="margin-top: 10px;">
                    </el-pagination>
                </div>
            </div>
        </div>
        <!--彈出的添加-->
        <el-dialog  :visible.sync="dialogTableVisible" fullscreen="true" :close-on-click-modal='false'>
            <router-view v-on:close="close"></router-view>
        </el-dialog>
    </div>
</template>
<script>

import { MessageBox, Loading} from 'element-ui'
import api from '../../com/ajax' // ajax请求封装
import config from '../../com/config' // url配置文件
import DoubleDate from '@/components/utils/DoubleDate.vue'

export default {
  name: 'app',
  data () {
    return {
            // 对象属性
        queryForm: {
            cityID: '',
            countryID: '',
            orgFirstType: '',
            orgSecondType: '',
            reportNumSort: '',
            reportStatus: '1',
            reportNumSort: 'DESC',
            provinceID: '',
            pageNum: 1,
            pageSize: 10
          },
        cityVisible: false, // 省级保健院有此选项
        isGuizhou: false, // 贵州省有此选项
        selectcity: [], // 筛选条件下拉框市数据
        selectarea: [], // 筛选条件下拉框区数据
        tableData: [],
        formInline: '', // 查询时要提交的数据
        total_rows: 0,
        orgSecondType: false,
        dialogTableVisible: false,
        garNum: '', // 幼儿园数量
        reportNum: '', // 查询幼儿园数量
        org: [],
        orgS: [// 公办集团
                { id: '', name: '全部' },
                { id: '11', name: '示范园' },
                { id: '12', name: '一级园' },
                { id: '13', name: '二级园' },
                { id: '14', name: '其他' }
          ],
        orgSguizhou: [// 公办集团-贵州
                { id: '', name: '全部' },
                { id: '21', name: '省级示范园' },
                { id: '32', name: '市级示范园' },
                { id: '33', name: '县级示范园' },
                { id: '34', name: '未评定' }
          ],
        orgSe: [// 民办集团
                { id: '', name: '全部' },
                { id: '21', name: '民办' },
                { id: '22', name: '民办集团' },
                { id: '23', name: '其他' }
          ]
      }
  },
  methods: {

    close (flag) { // 为子组件的返回($emit)按钮定义的事件
        this.dialogTableVisible = flag
      },
    pageSizeChange (val) { // 每页显示条数
        this.queryForm.pageSize = val

        this.queryForm.keyWord = this.keyWord

        this.getSurvey(this.queryForm)
      },
    pageCurrentChange (val) { // 分页
        this.queryForm.pageNum = val

        this.queryForm.keyWord = this.keyWord

        this.getSurvey(this.queryForm)
      },
    query (param) { // 查询按钮
        this.queryForm.pageNum = 1
        this.queryForm.keyWord = this.keyWord

        this.getSurvey(this.queryForm)
      },
    getSurvey (param) { // 获取页面列表
        api.post(config.host + 'report/getReportNumFromKhs.do', param).then((data) => {
            if (data.success == true) {
                this.queryForm.keyWord = this.keyWord

                this.tableData = data.body.list

                this.total_rows = data.body.page.total
                this.getNums()
              }
          })
      },
    survey (index, row) { // 查看
        if (row.reportNum == 0) {
            alert('错误！该幼儿园没有上报过报表')
          } else {
            window.localStorage.setItem('kindName', row.fullName)

            window.location.href = './reports.html'
          }
      },
    changeType () { // 机构类型显示与否和是否是贵州的判断
        let self = this
        if (self.queryForm.orgFirstType == 1) {
              self.orgSecondType = true
              self.queryForm.orgSecondType = ''

              if (self.isGuizhou == true) {
                self.org = self.orgSguizhou
              } else {
                self.org = self.orgS
              }
            } else if (self.queryForm.orgFirstType == 2) {
              self.org = self.orgSe
              self.orgSecondType = true
              self.queryForm.orgSecondType = ''
            } else {
              self.orgSecondType = false
            }
      },
    selectChange (sel, parentID) { // 地区下拉框值改变事件
        let self = this

        api.post(config.host + 'common/getAreasList.do', { 'parentID': parentID }).then(function (response) {
              if (sel == 'city') {
                self.selectarea = response.body.list

                self.selectarea.splice(0, 0, { 'id': '', 'name': '全部' })
              }
            })
      },
    getNums () { // 得到幼儿园数量
        api.post(config.host + 'orgkind/getOrgKindNum.do').then((data) => {
             if (data.success == true) {
                this.garNum = data.body
                if (this.queryForm.reportStatus == '1') {
                    $('#gartenNum').html('报表上报概况：（辖区已注册幼儿园合计：' + this.garNum + '家,当前查询中包括已上报和未上报的幼儿园数量合计：' + this.total_rows + '家）')
                  } else if (this.queryForm.reportStatus == '2') {
                      $('#gartenNum').html('报表上报概况：（辖区已注册幼儿园合计：' + this.garNum + '家,当前查询已上报幼儿园数量合计：' + this.total_rows + '家）')
                    } else if (this.queryForm.reportStatus == '3') {
                      $('#gartenNum').html('报表上报概况：（辖区已注册幼儿园合计：' + this.garNum + '家,当前查询未上报幼儿园数量合计：' + this.total_rows + '家）')
                    }
              }
           })
      }
  },
  created: function () {
    let that = this
    that.orgSecondType = false

    api.get(config.host + 'org/getOrgDetail.do').then((data) => {
          if (data.success == true) {
            that.queryForm.provinceID = data.body.provinceID

            that.queryForm.cityID = data.body.cityID

            if (data.body.provinceID == '520000') { // 贵州
                that.isGuizhou = true
              } else {
                that.isGuizhou = false
              }
            if (data.body.scopeType == 1) { // 省级妇保院，显示市，区
                that.cityVisible = true

                api.post(config.host + 'common/getAreasList.do', { 'parentID': that.queryForm.provinceID }).then(function (response) {
                    if (response.success == true) {
                        that.selectcity = response.body.list

                        that.selectcity.splice(0, 0, { 'id': '', 'name': '全部' })

                        that.selectarea = []
                      }
                  })

                api.post(config.host + 'report/getReportNumFromKhs.do', { 'pageNum': 1, 'pageSize': 10, 'reportStatus': that.queryForm.reportStatus, 'provinceID': that.queryForm.provinceID, 'reportNumSort': 'DESC'}).then((data) => {
                    if (data.success == true) {
                        that.total = data.body.page.total

                        that.tableData = data.body.list

                        that.total_rows = data.body.page.total

                        that.reportNum = data.body.list.reportNum

                        that.getNums()
                      }
                  })
              } else if (data.body.scopeType == 2) { // 非省级妇保院，显示区
                  that.cityVisible = false
                  api.post(config.host + 'common/getAreasList.do', { 'parentID': that.queryForm.cityID }).then(function (response) {
                    if (response.success == true) {
                         that.selectarea = response.body.list
                       }
                  })
                  api.post(config.host + 'report/getReportNumFromKhs.do', { 'pageNum': 1, 'pageSize': 10, 'reportStatus': that.queryForm.reportStatus, 'cityID': that.queryForm.cityID, 'reportNumSort': 'DESC'}).then((data) => {
                    if (data.success == true) {
                        that.total = data.body.page.total

                        that.tableData = data.body.list

                        that.total_rows = data.body.page.total

                        that.reportNum = data.body.list.reportNum

                        that.getNums()
                      }
                  })
                }
          }
        })
  },
  components: {// 日期控件的通用函数

    doubleDate: DoubleDate

  }
}
</script>

<style>
.detailtit {
    background: #f6f6f6;
    height: 60px;
    line-height: 60px;
    padding: 0 15px;
    font-size: 12px;
    border: 1px solid #e1e1e1;
    box-sizing: border-box;
    width: 100%;
    margin-bottom: 20px;
}

.detailtit i {
    font-style: normal;
}
.el-table th{
    background:#F5F5F5 !important;
    font-size:15px;
}
.set-row{
    margin-bottom:15px;
}
</style>



// WEBPACK FOOTER //
// src/components/berichten/berichten_survey.vue